import {
  AddToCartMutation,
  Allergen,
  CartQuery,
  CompletedOrderQuery,
  MenuItemDetailsQuery,
  MenuItemFromCartQuery,
  Menus_PricingRules as PricingRules,
  RestaurantSchedulesQuery,
  UnitOfMeasure
} from 'src/apollo/onlineOrdering'

export type AddCartData = AddToCartMutation['addItemToCartV2'] & {
  __typename: 'CartResponse'
}
export type CartData =
  | (CartQuery['cartV2'] & { __typename: 'CartResponse' })
  | undefined
  | null
export type Cart = NonNullable<CartData>['cart']
export type CartOrder = Cart['order']
type CartRestaurant = Cart['restaurant']

export type PreComputedTips = NonNullable<Cart>['preComputedTips']
export type DeliveryInfo = NonNullable<CartOrder>['deliveryInfo']
export type Location = NonNullable<CartRestaurant>['location']

export type ScheduleType = RestaurantSchedulesQuery['restaurants'][0] & {
  __typename: 'Restaurant'
}

export type ModifierGroup =
  MenuItemDetailsQuery['menuItemDetails']['modifierGroups'][0]
export type IModifierGroup = Omit<ModifierGroup, '__typename' | 'modifiers'> & {
  modifiers: IModifier[]
}
export type Modifier = ModifierGroup['modifiers'][0]
export type IModifier = Omit<Modifier, 'modifierGroups'> & {
  modifierGroups?: IModifierGroup[]
}

export type SelectionModifierGroup =
  MenuItemFromCartQuery['selectionItemDetails']['modifierGroups'][0]
export type ISelectionModifierGroup = Omit<
  SelectionModifierGroup,
  '__typename' | 'modifiers'
> & { modifiers: SelectionModifier[] }
export type SelectionModifier = Omit<
  SelectionModifierGroup['modifiers'][0],
  'modifierGroups'
> & { modifierGroups?: ISelectionModifierGroup[] }

export type CartSelections = NonNullable<
  NonNullable<
    (CartQuery['cartV2'] & { __typename: 'CartResponse' })['cart']['order']
  >['selections']
>
export type CartSelection = CartSelections[0]

// https://github.com/toasttab/toast-reservations-2012/blob/master/modules/toast-java-common/app/com/toasttab/models/PricingMode.java
export type PricingMode =
  | 'ADJUSTS_PRICE'
  | 'REPLACES_PRICE'
  | 'INCLUDED'
  | 'FIXED_PRICE'

export type Action = 'merge' | 'replace'

export type ModifierAllergenMap = {
  [modifierGuid: string]: {
    name: string
    allergens: (Allergen | null)[] | null | undefined
  }
}

export type ModifierGroupData = {
  [key: string]: {
    guid: string
    defaultOptionsChargePrice: string
    defaultOptionsSubstitutionPricing: string
    pricingRules: Partial<PricingRules>
  }
}

export type Selections = {
  [groupGuid: string]: { [itemGuid: string]: SelectedModifier }
}

export type SelectedModifier = {
  itemGroupGuid?: string | null
  itemGuid: string
  modifierGroups: Selections
  name?: string
  quantity: number
  isDefault?: boolean
  price?: number | null
}

export type WrappedModifier = {
  masterId?: string | null
  groupGuid: string
  modifier: Modifier
  modifierGroups: Selections
  isRoot?: boolean
  action: Action
  quantity?: number
  isDefault?: boolean
  price?: number | null
  specialInstructions?: string | null
  usesFractionalQuantity?: boolean | null
  unitOfMeasure?: UnitOfMeasure | null
  name?: string | null
}

export type CompletedOrder = CompletedOrderQuery['completedOrder'] & {
  __typename: 'CompletedOrder'
}
export type CompletedOrderSelections = CompletedOrder['selections']
export type CompletedOrderSelection = NonNullable<CompletedOrderSelections>[0]
type CompletedOrderModifierSelections = CompletedOrderSelection['modifiers']
export type CompletedOrderModifierSelection =
  NonNullable<CompletedOrderModifierSelections>[0]

export type PaymentIntent = {
  externalReferenceId: string
  amount: number
}

export type BillingDetails = {
  name?: string
  phoneNumber?: string
  email?: string
}

export type CardType =
  | 'VISA'
  | 'MASTERCARD'
  | 'AMEX'
  | 'DISCOVER'
  | 'JCB'
  | 'DINERS'
  | 'CITI'
  | 'MAESTRO'
  | 'LASER'
  | 'SOLO'
  | 'INTERAC'
  | 'UNKNOWN'

export type CardDetails = {
  lastFour?: string
  expiry?: Expiry
  brand?: CardType
  funding?: string
}

export type Expiry = {
  month: string
  year: string
}
export type CreatePaymentMethodResultEventContent = {
  paymentMethodType: string
  billingDetails?: BillingDetails
  paymentMethodId?: string
  error?: any
  card?: CardDetails
}

export type CreatePaymentMethodResultEvent = {
  content: CreatePaymentMethodResultEventContent
}

export enum ToastPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  NEW_CARD = 'NEW_CARD',
  SAVED_CARD = 'SAVED_CARD'
}
